// extracted by mini-css-extract-plugin
export default {"content":"Contract_content__qwIt1","signButton":"Contract_signButton__pb31j"};